import React from "react";
import "./HomeBlog.css";
import image from "../../Assets/Images/working.jpg";
import { Link } from "react-router-dom";

const HomeBlog = () => {
  return (
    <section class="container  blogs" id="blogs">
      <div data-aos="fade-down" data-aos-duration="2000">
        <h1 class="heading">
          {" "}
          <span>From My</span> Blog
        </h1>
      </div>

      <div class="blog-container">
        <div
          data-aos="zoom-in-up"
          data-aos-duration="2000"
          data-aos-anchor-placement="center-bottom"
        >
          <div class="card">
            <div class="circle">
              <div class="photo">
                <img src={image} alt="Jahidul Islam Zim" />
              </div>

              <div className="about">
                <h1>Server side work in progress. Please wait</h1>
              </div>
            </div>
            <div class="content">
              <p>Server side work in progress. Please wait</p>
              <Link to="">Read More</Link>
            </div>
          </div>
        </div>

        <div
          data-aos="zoom-in-up"
          data-aos-duration="2000"
          data-aos-anchor-placement="center-bottom"
        >
          <div class="card">
            <div class="circle">
              <div class="photo">
                <img src={image} alt="Jahidul Islam Zim" />
              </div>

              <div className="about">
                <h1>Server side work in progress. Please wait</h1>
              </div>
            </div>
            <div class="content">
              <p>Server side work in progress. Please wait</p>
              <Link to="">Read More</Link>
            </div>
          </div>
        </div>

        <div
          data-aos="zoom-in-up"
          data-aos-duration="2000"
          data-aos-anchor-placement="center-bottom"
        >
          <div class="card">
            <div class="circle">
              <div class="photo">
                <img src={image} alt="Jahidul Islam Zim" />
              </div>

              <div className="about">
                <h1>Server side work in progress. Please wait</h1>
              </div>
            </div>
            <div class="content">
              <p>Server side work in progress. Please wait</p>
              <Link to="">Read More</Link>
            </div>
          </div>
        </div>

        <div
          data-aos="zoom-in-up"
          data-aos-duration="2000"
          data-aos-anchor-placement="center-bottom"
        >
          <div class="card">
            <div class="circle">
              <div class="photo">
                <img src={image} alt="Jahidul Islam Zim" />
              </div>

              <div className="about">
                <h1>Server side work in progress. Please wait</h1>
              </div>
            </div>
            <div class="content">
              <p>Server side work in progress. Please wait</p>
              <Link to="">Read More</Link>
            </div>
          </div>
        </div>

        <div
          data-aos="zoom-in-up"
          data-aos-duration="2000"
          data-aos-anchor-placement="center-bottom"
        >
          <div class="card">
            <div class="circle">
              <div class="photo">
                <img src={image} alt="Jahidul Islam Zim" />
              </div>

              <div className="about">
                <h1>Server side work in progress. Please wait</h1>
              </div>
            </div>
            <div class="content">
              <p>Server side work in progress. Please wait</p>
              <Link to="">Read More</Link>
            </div>
          </div>
        </div>

        <div
          data-aos="zoom-in-up"
          data-aos-duration="2000"
          data-aos-anchor-placement="center-bottom"
        >
          <div class="card">
            <div class="circle">
              <div class="photo">
                <img src={image} alt="Jahidul Islam Zim" />
              </div>

              <div className="about">
                <h1>Server side work in progress. Please wait</h1>
              </div>
            </div>
            <div class="content">
              <p>Server side work in progress. Please wait</p>
              <Link to="">Read More</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeBlog;
